import React from 'react';
import { Box, makeStyles, Typography, Link as MaterialLink } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { MobileHighlightPage } from '../../../components';
import { AppButton } from "../../mobile/components/InputComponents";

import logo from '../../../images/logo.png';

const useStyles = makeStyles((theme) => ({
    logoSection: {
        marginTop: '40px',
        marginBottom: '40px'
    },
    textSection: {
        marginBottom: '30px',
        marginLeft: '10%',
        marginRight: '10%'
    },
    textHighlight: {
        color: theme.palette.secondary.main,
        fontWeight: 'bold'
    },
    footer: {
        padding: 20,
        marginTop: 'auto',
        '& p': {
            font: '10px',
            '& a': {
                color: 'white'
            }
        },
        width: '100%'
    },
}));

const Welcome = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <MobileHighlightPage>
            <Box className={classes.logoSection}>
                <img src={logo} alt="logo" />
            </Box>
            <Box className={classes.textSection}>
                <Typography variant="h3" style={{ marginBottom: '30px' }}>
                    {t('welcome.message')} RepLI
                </Typography>
                <Typography variant="h5">
                    {t('welcome.appExplanation')}
                </Typography>
            </Box>
            <Box className={classes.footer}>
                <p>
                    <MaterialLink component={Link} to="/app/signin">
                        {t('welcome.signInQuestion')}
                    </MaterialLink><br />
                </p>
                <AppButton 
                    variant="contained"
                    color="secondary"
                    fullWidth
                    size="large"
                    component={Link} 
                    to="/app/terms"
                >
                    {t('welcome.getStartedButtonLabel')}
                </AppButton>
            </Box>
        </MobileHighlightPage>
    );
};

export default Welcome;